import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxFileDropModule } from 'ngx-file-drop';
import { JoyrideModule } from 'ngx-joyride';
import { ClearSearchComponent } from './components/clear-search/clear-search.component';
import { DataEnrichmentComponent } from './components/data-enrichment/data-enrichment.component';
import { HeaderComponent } from './components/header/header.component';
import { ModalComponent } from './components/modal/modal.component';
import { PromptModalComponent } from './components/prompt-modal/prompt-modal.component';
import { TrialExpiredComponent } from './components/trial-expired/trial-expired.component';
import { LoadingIndicatorsService } from './services/LoadingIndicators.service';
import { OauthService } from './services/oauth.service';
import { OverlayLoaderComponent } from './overlay-loader/overlay-loader.component';
import { AddToListContactsComponent } from './components/add-to-list-contacts/add-to-list-contacts.component';
import { RouterModule } from '@angular/router';
import { RequestResearchModalComponent } from './components/request-research-modal/request-research-modal.component';
import { headerComponentDeclarations } from './components/header';
import { MapFieldsFormModule, MultiSelectorFormFieldModule, SiModalModule } from './components';
import { HasAccessPipeModule, IsAppEnabledForAdminPipeModule, LimitToPipeModule, OrderByPipeModule, IsFeatureFlagEnabledPipeModule, GetAddressPipeModule, AllKeysPipeModule } from './pipes';
import { FilterSavedSearchComponent } from './components/filter-saved-search/filter-saved-search.component';
import { ContactVerificationPipe } from './components/request-research-modal/pipes/contact-verification.pipe';
import { ModalHeaderWizardComponent } from './components/modal-header-wizard/modal-header-wizard.component';
import { HubspotCrmPromptModule } from './components/hubspot-crm-prompt/hubspot-crm-prompt.module';
import { ClipboardModule } from 'ngx-clipboard';

import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ExistingListSelectorComponent } from './components/existing-list-selector/existing-list-selector.component';
import { UserMetaDataByKeyPipeModule } from './pipes/user-meta-data-by-key';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  TechnologyMapFieldsFormModule
} from './components/ui-components/technology-map-fields-form/technology-map-fields-form.module';
import { ReConnectSettingModule } from './components/re-connect-setting/re-connect-setting.component.module';
import { ActionConfirmationDialogModule } from './components/action-confirmation-dialog/action-confirmation-dialog.module';
import { OverlayDropdownComponent } from './components/overlay-dropdown/overlay-dropdown.component';
import { DropdownPanelDirective, DropdownTriggerDirective } from './components/overlay-dropdown/overlay-dropdown.directive';

@NgModule({
    declarations: [
        ModalComponent,
        PromptModalComponent,
        TrialExpiredComponent,
        ClearSearchComponent,
        DataEnrichmentComponent,
        OverlayLoaderComponent,
        AddToListContactsComponent,
        RequestResearchModalComponent,
        ...headerComponentDeclarations,
        FilterSavedSearchComponent,
        ContactVerificationPipe,
        ModalHeaderWizardComponent,
        ExistingListSelectorComponent,
    ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxFileDropModule,
        JoyrideModule.forChild(),
        RouterModule,
        // Backward compatibility, use directly these modules in future
        HasAccessPipeModule,
        LimitToPipeModule,
        MapFieldsFormModule,
        OrderByPipeModule,
        IsAppEnabledForAdminPipeModule,
        TechnologyMapFieldsFormModule,
        HubspotCrmPromptModule,
        IsFeatureFlagEnabledPipeModule,
        GetAddressPipeModule,
        AllKeysPipeModule,
        MatButtonModule,
        MatTooltipModule,
        MatSidenavModule,
        MatListModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatMenuModule,
        SiModalModule,
        MultiSelectorFormFieldModule,
        ScrollingModule,
        FontAwesomeModule,
        ClipboardModule,
        UserMetaDataByKeyPipeModule,
        ReConnectSettingModule,
        ActionConfirmationDialogModule,
        OverlayDropdownComponent,
        DropdownTriggerDirective,
        DropdownPanelDirective,
    ],
    exports: [
        ModalComponent,
        HeaderComponent,
        PromptModalComponent,
        TrialExpiredComponent,
        NgxFileDropModule,
        JoyrideModule,
        DataEnrichmentComponent,
        OverlayLoaderComponent,
        FilterSavedSearchComponent,
        ModalHeaderWizardComponent,
        // Backward compatibility, use directly these modules in future
        HasAccessPipeModule,
        LimitToPipeModule,
        MapFieldsFormModule,
        OrderByPipeModule,
        IsAppEnabledForAdminPipeModule,
        TechnologyMapFieldsFormModule,
        FontAwesomeModule,
        IsFeatureFlagEnabledPipeModule,
        GetAddressPipeModule,
        AllKeysPipeModule,
        ExistingListSelectorComponent,
    ],
    providers: [
        OauthService,
        LoadingIndicatorsService,
    ]
})
export class SharedModule {
    static injector: Injector;

    constructor(injector: Injector) {
        SharedModule.injector = injector;
    }
}
